module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"structureTitle":"Events","structureSubTitle":"Select a sensor to view all the data that have always been detected."},"it":{"structureTitle":"Eventi","structureSubTitle":"Seleziona un sensore di cui visualizzare tutti i dati rilevati da sempre."}}')
  delete Component.options._Ctor
}
